import { MessageOverlayContent } from "@/components/overlay/message-overlay/message-overlay-content";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";

export const MessageOverlay = observer(function MessageOverlay() {
  const { store } = useAppStore();
  return <MessageOverlayContent message={store?.modals.message} />;
});
